<template lang="pug">

    div

        h5
            | Interne Notiz
            a.edit(v-on:click='showModal()'): i.edit.icon

        //- Notiz zum Produkt
        p.ui.info.message(v-if='note.length === 0') Keine interne Notiz vorhanden
        p(v-else v-html="note")

        // Formular-Modal
        modal(ref="modal")

            //- Header
            span(slot="header") Interne Notiz bearbeiten

            //- Formular
            .ui.form(slot="content")
                textarea-field(
                    label='Notiz (Zeilenumbrüche werden in der Übersicht ebenfalls dargestellt)'
                    v-model="mutableValue"
                )

            //- Action-Bar
            action-row(slot="footer" v-on:cancel="cancel()" v-on:save="submit()")

</template>
<script>
    import * as R from 'ramda'
    import nl2br from 'nl2br'
    import Modal from '@/components/app/Modal'
    import ActionRow from '@/components/form/ActionRow'
    import TextareaField from '@/components/form/TextareaField'

    export default {

        components: { ActionRow, TextareaField, Modal },

        created() {
            this.mutableValue = this.product.note
        },

        computed: {
            note() {
                return R.compose(

                    // nl2br wenn Notiz vorhanden
                    R.when(
                        R.propSatisfies(length => length > 0, 'length'),
                        notice => nl2br(notice, true)
                    ),

                    // Trimmen
                    R.trim,

                    // ggf. Standardwert setzen
                    R.defaultTo('')

                )(this.product.note)
            }
        },

        data() {
            return {
                mutableValue: ''
            }
        },

        methods: {

            cancel() {
                this.$refs.modal.close()
                this.mutableValue = this.product.note
            },

            async submit() {
                // Model erstellen
                const model = R.assoc('note', this.mutableValue, this.product)

                // Speichern
                try {
                    await this.$store.dispatch('products/update', { id: model.id, model })

                    // Growl anzeigen
                    this.$growl.success('Bemerkung zum Produkt wurde gespeichert')

                    // Modal closen
                    this.$refs.modal.close()

                } catch(e) {
                    // Fehler anzeigen
                    this.$growl.fatal('Notiz zu Produkt konnte nicht gespeichert werden', e)
                }
            },

            showModal() {
                this.$refs.modal.show()
            },

        },

        props: {
            product: {
                type: Object,
                required: true
            }
        }

    }

</script>

<style scoped>

    /*noinspection CssUnusedSymbol*/
    .edit {
        cursor: pointer;
        float: right;
    }

</style>
